<template>
  <div class="py-6 pb-md-0 pt-md-8" style="background-color: #f5f5f6 !important">
    <v-card v-if="isRating" class="rating-card d-flex align-center justify-space-between py-4 px-6 elevation-0">
      <v-progress-circular
        :rotate="-90"
        :value="partner_rating"
        color="#88BD1F"
        :width="$vuetify.breakpoint.xs ? '15' : '8'"
        :size="$vuetify.breakpoint.xs ? '180' : '80'"
        class="mr-6"
        @click="showRatingPanel(true)"
        style="cursor: pointer"
      >
        <span :class="$vuetify.breakpoint.xs ? 'font font-weight-medium' : 'font font--h2-2'"
          >{{ partner_rating }} %</span
        ></v-progress-circular
      >
      <v-row class="pa-0">
        <v-col md="4" cols="12" class="px-0 px-md-4 ml-7 ml-md-0 font">
          <span class="d-block font--h2">Ваш рейтинг партнёра</span>
          <span v-if="subcategoryRewardTitle" class="d-block text-subtitle-2"
            >Статус: {{ subcategoryRewardTitle }}
          </span>
          <v-btn
            text
            plain
            elevation="0"
            x-small
            :ripple="false"
            class="d-block text-subtitle-2 accent--text text--darken-3 pa-0"
            style="text-transform: none;"
            @click="showRatingPanel(true)"
            >Подробнее
          </v-btn>
        </v-col>

        <template v-if="left_to_calculate <= 0 || left_to_calculate === null">
          <v-col v-if="isActive" md="2" cols="5" class="py-1 d-md-block d-flex">
            <span class="d-block d-md-none font text-caption font-weight-medium mr-2 ml-4"> {{ active_score }}%</span>
            <div class="text-caption font--color_light">
              Активность
            </div>
            <div class="d-none d-md-inline-flex mt-2">
              <v-img
                class="mt-1"
                src="@/assets/img/user.svg"
                style="width: 18px; height: 18px; margin-right: 10px"
              ></v-img
              ><span class="font font--h2"> {{ active_score }}%</span>
            </div>
          </v-col>
          <v-col v-if="isQuality" md="2" cols="5" class="py-1 d-md-block d-flex">
            <span class="d-block d-md-none font text-caption font-weight-medium mr-2 ml-4"> {{ quality_score }}%</span>
            <div class="text-caption font--color_light">Качество</div>
            <div class="d-none d-md-inline-flex mt-2">
              <v-img
                class="mt-1"
                src="@/assets/img/cup.svg"
                style="width: 18px; height: 18px; margin-right: 10px"
              ></v-img>
              <span class="font font--h2">{{ quality_score }}%</span>
            </div>
          </v-col>
          <v-col v-if="isConversation" md="2" cols="5" class="pb-4 pt-1 d-md-block d-flex">
            <span class="d-block d-md-none font text-caption font-weight-medium mr-2 ml-4"> {{ conversion_score }}%</span>
            <div class="text-caption font--color_light">Конверсия</div>
            <div class="d-none d-md-inline-flex mt-2">
              <v-img
                class="mt-1"
                src="@/assets/img/change.svg"
                style="width: 18px; height: 18px; margin-right: 10px"
              ></v-img>
              <span class="font font--h2">{{ conversion_score }}%</span>
            </div>
          </v-col>
          <v-col v-if="isProfit" md="2" cols="5" class="pb-4 pt-1 d-md-block d-flex">
            <span class="d-block d-md-none font text-caption font-weight-medium mr-2 ml-4"> {{ profit_score }}%</span>
            <div class="text-caption font--color_light">Доходность</div>
            <div class="d-none d-md-inline-flex mt-2">
              <v-img
                class="mt-1"
                src="@/assets/img/coins.svg"
                style="width: 18px; height: 18px; margin-right: 10px"
              ></v-img>
              <span class="font font--h2">{{ profit_score }}%</span>
            </div>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12" class="ml-md-0 ml-4 d-block">
            <span class="font text-subtitle-2">Для расчёта показателей необходимо совершить {{ leftToCalculateTitle }}</span>
          </v-col>
        </template>
      </v-row>
    </v-card>
    <SidePanel v-model="showRating">
      <RatingSidePanel
        :partner_rating="Number(partner_rating)"
        :conversion_score="Number(conversion_score)"
        :profit_score="Number(profit_score)"
        :active_score="Number(active_score)"
        :quality_score="Number(quality_score)"
        :close-panel="showRating"
      />
    </SidePanel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidePanel from "@/components/common/SidePanel";
import RatingSidePanel from "@/components/bids/RatingSidePanel.vue";
import { isDigit, pluralize } from "@/utils/helpers";

const subcategoryRewards = {
  'start': 'Простой',
  'average': 'Серебряный',
  'elder': 'Золотой'
};

export default {
  name: "Rating",
  components: {
    SidePanel,
    RatingSidePanel,
  },

  computed: {
    ...mapGetters("profile", ["partner_rating", "conversion_score", "profit_score", "active_score", "quality_score", "subcategory_reward","left_to_calculate"]),
    isRating() {
      return isDigit(this.partner_rating);
    },
    isConversation() {
      return isDigit(this.conversion_score);
    },
    isProfit() {
      return isDigit(this.profit_score);
    },
    isActive() {
      return isDigit(this.active_score);
    },
    isQuality() {
      return isDigit(this.quality_score);
    },
    subcategoryRewardTitle() {
      return subcategoryRewards[this.subcategory_reward] ?? null;
    },
    leftToCalculateTitle() {
      return pluralize(this.left_to_calculate, ['сделку', 'сделки', 'сделок']);
    },

    showRating: {
      get() {
        return this.$store.state.profile.showRatingPanel;
      },
      set(value) {
        this.$store.commit("profile/showRatingPanel", value);
      },
    },
  },
  methods: {
    showRatingPanel(v) {
      this.$store.commit("profile/showRatingPanel", v);
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-card {
  min-height: 112px;
}
</style>
